/**************
 Search
 ***************/

// Show search form on click
document.querySelector("#headerSearchButton").addEventListener("click", function () {
    document.querySelector("#headerSearch").classList.toggle("open");
    document.querySelector("#headerSearchFormInput").focus();
});

// close search form on outside click
document.addEventListener("click", function (event) {
    if (!event.target.closest("#headerSearch") && !event.target.closest("#headerSearchButton")) {
        document.querySelector("#headerSearch").classList.remove("open");
    }
});

/*************
 Profile Switcher
 **************/

// check for profiles
if (document.querySelector("#headerProfiles") && localStorage.getItem("profiles")) {
    // show profile select
    document.querySelector("#headerProfiles").classList.add("active");

    // parse profiles
    const profiles = JSON.parse(localStorage.getItem("profiles"));

    // generate option HTML
    let options = "";
    profiles.forEach(profile => {
        options += `<option value="${profile.accessToken}" ${profile.accessToken === localStorage.getItem("accessToken") ? "selected" : ""}>${profile.name}</option>`;
    });

    // insert options
    document.querySelector("#headerProfiles").innerHTML = options;

    // add event listener to select
    document.querySelector("#headerProfiles").addEventListener("change", async function () {
        // save access token
        localStorage.setItem("accessToken", this.value);

        // login to Shopify
        await b2b.loginViaMultipass();
    });
}

/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("#slider").classList.add("active");
    document.querySelector('#sliderContent').classList.add('active');
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector('#sliderContent').classList.remove('active');
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));